import { useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useSelector } from "react-redux";
import { baseContainer } from "@base-provider";

const useTimer = () => {
  const session = useSelector((state) => state.session);

  const onAction = () => idleTimer.reset();

  const onIdle = () => {
    idleTimer.pause();
    baseContainer.authenticationService.logout();
  };

  const idleTimer = useIdleTimer({
    onIdle,
    onAction,
    timeout: 1000 * session.timeout,
    eventsThrottle: 200,
    startOnMount: false,
    startManually: true,
    stopOnIdle: true,
    crossTab: false
    //TODO: Temporarily switched to false, should be enabled
    // crossTab: {
    //   emitOnAllTabs: true
    // }, 
  });

  useEffect(() => {
    if (session && session.timeout) {
      idleTimer.reset();
    }

    return () => idleTimer.pause();
  }, [session]);

  return idleTimer;
};

export default useTimer;
